import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=b311c5d0"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=b311c5d0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b311c5d0')) {
      api.createRecord('b311c5d0', component.options)
    } else {
      api.reload('b311c5d0', component.options)
    }
    module.hot.accept("./addModal.vue?vue&type=template&id=b311c5d0", function () {
      api.rerender('b311c5d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/labelManage/addModal.vue"
export default component.exports